export default {
    "entityTagViewer_units": "View by Unit",
    "entityTagViewer_drivers": "View by Driver",
    "entityTagViewer_landmarks": "View by Landmark",
    "entityTagViewer_geofences": "View by Geofence",
    "entityTagViewer_forms": "View by Form",
    "entityTagViewer_users": "View by User",
    "entityTagViewer_tag": "View by Tag",
    "entityTagViewer_notFound": "Not items found",
}